import React from 'react';

import {SkeletonItem} from './skeleton-item';

type Props = {
    children: React.ReactNode,
    labelWidth: number,
};
export const FormItemSkeleton = ({children, labelWidth}: Props) => (
    <div>
        <div className="pb-xs">
            <SkeletonItem width={labelWidth} height={16}/>
        </div>
        {children}
    </div>
);
